import { schema } from 'normalizr';

export const serviceSchema = new schema.Entity('services');

export const servicesListSchema = new schema.Array(serviceSchema);
